import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from "react-leaflet";
// import L from "leaflet";
import SearchMapAddress from "src/pages/packages/create/components/SearchMapAddress";
import { useMapSuggestionLatLngLazyQuery } from "src/graphql/codegen_graphql";
import { TextField } from "@shopify/polaris";

interface MyMarker {
  enableClick: Boolean;
  lat: number;
  lng: number;
  setCoord: ({ lat, lng }: { lat: number; lng: number }) => void;
  address: string;
  setAddress: (address: string) => void;
}

const MyMarker = (props: MyMarker) => {
  const [getGeoAddress] = useMapSuggestionLatLngLazyQuery({
    onCompleted: (r) => props.setAddress((r.mapSuggestionLatLng || [{ name: "" }])[0]?.name?.toString() || ""),
  });

  const m = useMap();

  useMapEvents({
    click: (e) => {
      if (!!props?.enableClick) {
        const lat = Number(e.latlng?.lat);
        const lng = Number(e.latlng?.lng);
        if (props.lat !== lat && props.lng !== lng) {
          props.setCoord({ lat, lng });
          getGeoAddress({ variables: { lat: lat, lng: lng } });
        }
      }
    },
  });

  useEffect(() => {
    m.flyTo({ lat: props.lat, lng: props.lng }, m.getZoom());
  }, [m, props]);

  return (
    <Marker
      position={{ lat: props.lat, lng: props.lng }}
      eventHandlers={{
        click: (e) => {
          console.log(e);
        },
      }}
    ></Marker>
  );
};

export default function SellerLocation({
  lat,
  lng,
  addressName,
  onChange,
}: {
  lat?: number;
  lng?: number;
  addressName?: string;
  onChange: (lat: number, lng: number, addressName: string) => void;
}) {
  const [show, setShow] = useState(false);
  const [enableClick, setEnableClick] = useState<boolean>(true);
  const [address, setAddress] = useState(addressName);
  const [coord, setCoord] = useState<{ lat: number; lng: number }>({
    lat: lat || 11.5762787,
    lng: lng || 104.9226139,
  });

  const [, setCurrentLocation] = useState<{ lat: number; lng: number }>({
    lat: 11.5762787,
    lng: 104.9226139,
  });

  const [geocodeAddress] = useMapSuggestionLatLngLazyQuery();

  // const redIcon = new L.Icon({
  //   iconUrl: "/assets/red_pin.png",
  //   shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  //   iconSize: [26, 46],
  //   iconAnchor: [12, 41],
  //   popupAnchor: [1, -34],
  //   shadowSize: [41, 41],
  // });

  const onChangeAddress = (p: { lat: number; lng: number; address?: string }) => {
    const latlng = { lat: Number(p.lat), lng: Number(p.lng) };
    setCoord(latlng);
    setAddress(p.address || "");
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(({ coords: { latitude: lat, longitude: lng } }) => {
        const latlng = { lat, lng };
        setCurrentLocation(latlng);
      });
      if (!lat && !lng) {
        navigator.geolocation.getCurrentPosition(({ coords: { latitude: lat, longitude: lng } }) => {
          const latlng = { lat, lng };
          setCoord(latlng);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div onClick={() => setShow(true)}>
        {addressName ? (
          <small>
            <i className="fas fa-map-marker-alt" style={{ color: "#f44336" }}></i> &nbsp;
            {addressName}
          </small>
        ) : (
          <small>
            <i>Please select location</i>
          </small>
        )}
      </div>
      <Dialog open={show} fullWidth={true} maxWidth="md" onClose={() => setShow(false)}>
        <DialogTitle>Select your location</DialogTitle>
        <DialogContent>
          <div style={{ width: "100%", marginBottom: 10 }}>
            <SearchMapAddress
              address={address || ""}
              onChangeAddress={onChangeAddress}
              enableClick={enableClick}
              setEnableClick={setEnableClick}
              noEnabled
            />
            <MapContainer
              center={coord}
              scrollWheelZoom={true}
              style={{ width: "100%", height: 400 }}
              zoom={14}
              fadeAnimation
              zoomAnimation
              markerZoomAnimation
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />

              <MyMarker
                {...coord}
                enableClick={enableClick}
                setCoord={setCoord}
                address={address || ""}
                setAddress={setAddress}
              />

              {/* <>
                <Marker position={currentLocation} icon={redIcon} />
                <Circle center={currentLocation} radius={150} fillColor={"#ff4646"} color="#ff4646" />
              </> */}
            </MapContainer>
            <br />
            <TextField
              prefix="GPS(lat,lng)"
              autoComplete="off"
              value={coord.lat + "," + coord.lng}
              label
              labelHidden
              readOnly
            />
            <br />
            <TextField autoComplete="off" value={address || ""} prefix="Address" label labelHidden readOnly />
            <br />
            <button
              className="btn btn-primary"
              onClick={() => {
                geocodeAddress({
                  variables: {
                    lat: Number(coord.lat),
                    lng: Number(coord.lng),
                  },
                }).then((res) => {
                  console.log(res.data?.mapSuggestionLatLng);
                  let location = address;
                  if ((res.data?.mapSuggestionLatLng || []).length > 0) {
                    location = (res.data?.mapSuggestionLatLng || [{ name: "" }])[0]?.name || "";
                  }
                  onChange(coord?.lat as number, coord?.lng as number, location || "");
                  setShow(false);
                });
              }}
            >
              Save
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
